import React from 'react'
import { Link } from '../global'

import './author.scss'

export const Author = ({
  author: { avatar, name, description, email, role },
}) => {
  return (
    <div className="blogg-author-container">
      {avatar && <img src={avatar} alt="img" />}
      <div>
        <h3>{name}</h3>
        <p>{description}</p>

        <Link
          href={`mailto:${email || ''}`}
          className={`social-email ${role}`}
          aria-label={`Send email to ${email || ''}`}
        >
          <span>@</span>
        </Link>
      </div>
    </div>
  )
}
